import { Img } from "../../../layout/Img"
import { LinkField } from "../../linkField"

export const CallToAction = ({ cta, style }) => {
  const { ctaHeading, ctaContent, ctaLink, ctaBGImage } = cta[0]

  if (style === "rowWhite" || style === "rowBlueOverlay") {
    return (
      <div className="relative">
        {ctaBGImage && (
          <Img
            className="absolute w-full h-full cta-img"
            image={ctaBGImage[0]}
          />
        )}
        <div
          className={`${
            style === "rowWhite"
              ? "bg-white text-secondary"
              : "bg-primary text-white"
          }  absolute w-full h-full cta-bg`}
        />

        <div className="max-w-5xl px-4 py-20 mx-auto text-center xl:text-left sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
          <div>
            <span
              className={`${
                style === "rowWhite" ? "text-secondary" : "text-white"
              } text-3xl font-semibold leading-10lg:text-4xl`}
            >
              {ctaHeading}
            </span>
            {ctaContent && (
              <div
                className={`${
                  style === "rowWhite" ? "text-secondary" : "text-white"
                } pt-8 text-xl font-light leading-8 text-center  xl:w-10/12 xl:text-left text-justify-center`}
                dangerouslySetInnerHTML={{ __html: ctaContent }}
              />
            )}
          </div>

          <div className="flex mt-8 lg:mt-0 lg:flex-shrink-0">
            <div className="inline-flex mx-auto rounded-md shadow">
              {ctaLink && (
                <div className="cursor-pointer">
                  <LinkField
                    {...ctaLink}
                    className="inline-block px-10 py-4 font-semibold text-center text-white rounded bg-pink hover:bg-btnhover"
                  >
                    {ctaLink.text}
                  </LinkField>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
  if (style === "columnWhite" || style === "columnBlueOverlay") {
    return (
      <div className="relative inline-block w-full overflow-hidden">
        {ctaBGImage && (
          <Img
            className="absolute w-full h-full cta-img"
            image={ctaBGImage[0]}
          />
        )}
        <div
          className={`${
            style === "columnWhite" ? "bg-white text-secondary" : "bg-primary"
          }  absolute w-full h-full cta-bg`}
        />
        <div className="py-24">
          <div className="z-10">
            <h1
              className={`${
                style === "columnWhite" ? "text-secondary" : "text-white"
              } text-3xl font-semibold leading-10 text-center lg:text-4xl`}
            >
              {ctaHeading}
            </h1>
            {ctaContent && (
              <div
                className={`${
                  style === "columnWhite" ? "text-secondary" : "text-white"
                } w-10/12 pt-8 mx-auto text-xl font-light leading-9 text-center  md:w-7/12 text-justify-center`}
              />
            )}

            <div className="flex justify-center pt-16 mx-auto ">
              {ctaLink && (
                <div className="cursor-pointer">
                  <LinkField
                    {...ctaLink}
                    className="inline-block px-10 py-4 font-semibold text-center text-white rounded bg-pink hover:bg-btnhover"
                  >
                    {ctaLink.text}
                  </LinkField>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
  return <div>Nothing Found</div>
}